import { defineAbility } from '@casl/ability';
import defineRules from './defineRules';

export default defineAbility((can, cannot) => {
  defineRules(can, cannot);
});
